import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: 100%;
    height: 100%;
  }

  /* Toggle Button Group */
  .toggle-button-group {
    display: flex;
    gap: 0;
    border-radius: var(--sds-size-radius-200);
    border: 1px solid var(--sds-color-border-default-default);
    overflow: hidden;
    width: fit-content;
  }

  .toggle-button {
    padding: var(--sds-size-space-200) var(--sds-size-space-400);
    border: none;
    background: var(--sds-color-background-default-default);
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-body-font-family);
    font-size: var(--sds-typography-body-medium-font-size);
    font-weight: var(--sds-typography-body-medium-font-weight);
    line-height: var(--sds-typography-body-medium-line-height);
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
  }

  .toggle-button:first-child {
    border-right: 1px solid var(--sds-color-border-default-default);
  }

  .toggle-button:hover {
    background: var(--sds-color-background-default-secondary);
    color: var(--sds-color-text-default-primary);
  }

  .toggle-button.active {
    background: var(--sds-color-background-brand-primary);
    color: var(--sds-color-text-on-brand-primary);
  }

  .toggle-button.active:hover {
    background: var(--sds-color-background-brand-primary-hover);
  }

  [slot="main-content"] {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }

  /* Main Content Container */
  .main-content {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  /* Filter Buttons */
  .filter-buttons {
    display: flex;
    gap: var(--sds-size-space-600);
    flex-shrink: 0;
    margin-bottom: var(--sds-size-space-400);
  }

  /* Empty State */
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
  }

  .empty-state-title {
    margin: 0;
    color: var(--sds-color-text-default-primary);
    font-family: var(--sds-typography-heading-font-family);
    font-size: var(--sds-typography-heading-large-font-size);
    font-weight: var(--sds-typography-heading-large-font-weight);
    line-height: var(--sds-typography-heading-large-line-height);
  }

  .empty-state-subtitle {
    margin: 0;
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-body-font-family);
    font-size: var(--sds-typography-body-medium-font-size);
    font-weight: var(--sds-typography-body-medium-font-weight);
    line-height: var(--sds-typography-body-medium-line-height);
    max-width: 400px;
  }

  /* Posts Grid */
  .posts-grid {
    flex: 1;
    min-height: 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: var(--sds-size-space-400);
    width: 100%;
    align-content: start;
  }

  /* Loading and Error States */
  .loading,
  .error,
  .no-posts {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    padding: var(--sds-size-space-600);
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-body-font-family);
    font-size: var(--sds-typography-body-medium-font-size);
    text-align: left;
  }

  .skeleton-rectangle {
    border-radius: var(--sds-size-radius-200);
  }

  /* Empty State - Keep centered for this specific case */
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 12px;
    flex: 1;
    padding: var(--sds-size-space-600);
  }

  .error {
    color: var(--sds-color-text-danger-default);
  }

  .toggle-button:focus:not(:focus-visible) {
    outline: none;
  }
`;
